/**
 * Reports API service for the report registry
 */

import { apiClient } from './api'
import type { ReportMetadata, ListReportsParams, ReportDomain, ReportAccess } from '../types'

/**
 * List available reports with optional filters
 */
export async function listReports(params?: ListReportsParams): Promise<ReportMetadata[]> {
  const searchParams = new URLSearchParams()
  if (params?.domain) searchParams.set('domain', params.domain)
  if (params?.access) searchParams.set('access', params.access)

  const query = searchParams.toString()
  const endpoint = `/admin/reports${query ? `?${query}` : ''}`
  return apiClient.get<ReportMetadata[]>(endpoint)
}

/**
 * Get reports filtered by domain
 */
export async function getReportsByDomain(domain: ReportDomain): Promise<ReportMetadata[]> {
  return listReports({ domain })
}

/**
 * Get reports filtered by access level
 */
export async function getReportsByAccess(access: ReportAccess): Promise<ReportMetadata[]> {
  return listReports({ access })
}
